import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createEnquiry = async (payload) => {
  const { data } = await axios.post(`${API}/enquiries`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
};
